import { ref } from 'vue';

import type { ToastMessage } from '@/interfaces/error';
import type { Toast } from '@/interfaces/toast';

const toasts = ref<Toast[]>([]);

export const useToast = () => {
  const showToast = (message: ToastMessage): void => {
    const id = Date.now() + Math.random();
    toasts.value.push({ id, ...message });

    // Auto-remove after 10s
    setTimeout(() => {
      removeToast(id);
    }, 10000);
  };

  const removeToast = (id: number): void => {
    toasts.value = toasts.value.filter((t) => t.id !== id);
  };

  return { toasts, showToast, removeToast };
};
